import React from "react";
import { motion } from "framer-motion";

const DashboardLayout = ({
  children,
  sidebar,
  header,
  isDarkMode,
  themeClasses,
  initialLoading,
  favicon,
  isMobile,
  isMenuOpen,
  onCloseMenu,
}) => {
  return (
    <div className={`flex h-screen ${themeClasses.layout}`}>
      {/* Initial Loading Overlay */}
      {initialLoading && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="absolute inset-0 bg-gray-900/70 backdrop-blur-sm"></div>

          <motion.div
            className="relative"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7 }}
          >
            <div className="flex flex-col items-center">
              {/* Rotating circular icon */}
              <div className="relative w-16 h-16">
                <motion.div
                  className="w-full h-full"
                  animate={{ rotate: 360 }}
                  transition={{
                    duration: 2,
                    ease: "linear",
                    repeat: Infinity,
                  }}
                >
                  <img
                    src={favicon}
                    alt="Loading"
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      console.log("Image failed to load:", e.target.src);
                      e.target.style.display = "none";
                    }}
                  />
                </motion.div>
              </div>

            </div>
          </motion.div>
        </div>
      )}

      {/* Sidebar */}
      {sidebar}

      {/* Mobile overlay to close sidebar when clicking outside */}
      {isMobile && isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-[1px] z-40"
          onClick={onCloseMenu}
        />
      )}

      {/* Main Content Area */}
      <div
        className="flex-1 p-4 sm:p-10 overflow-y-auto font-body relative"
      >
        {/* Header */}
        {header}

        {/* Main Content */}
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;
